import React, { useState, useContext } from "react";
import { Modal } from "antd";
import { AuthContext } from "context/AuthContext";
import { showToast } from "ui/components/common";
import { getUser, shareAlert } from "lib/actions"; // Ensure getUser fetches user by ID
import UserSelect from "pages/dashboard/schedule/components/userSelect";
import "./share-alert-modal.scss";
const ShareAlertModal = ({ isOpen, onRequestClose, alertId }) => {
  const { user } = useContext(AuthContext);
  const [contactInfo, setContactInfo] = useState("");
  const [expiration, setExpiration] = useState("1440"); // Default to 1 day (1440 minutes)
  const [note, setNote] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]); // State to store selected users from UserSelect

  const clearForm = () => {
    setContactInfo("");
    setExpiration("1440");
    setNote("");
    setSelectedUsers([]); // Clear selected users
  };

  const handleClose = () => {
    clearForm();
    onRequestClose();
  };

  const handleUserSelect = (selectedOptions) => {
    // Set selected users to their `value` (user ID)
    const userIds = selectedOptions.map((option) => option.value); // Extract user IDs
    setSelectedUsers(userIds); // Store just the user IDs in state
    console.log("Selected User IDs: ", userIds);
  };
  const handleShare = async () => {
    try {
      const emailArray = [];
      const phoneNumberArray = [];
      const contacts = contactInfo
        .split(/[\s,;]+/)
        .filter((contact) => contact);

      let hasInvalidContact = false;

      contacts.forEach((contact) => {
        if (/^\d{10}$/.test(contact)) {
          phoneNumberArray.push(contact);
        } else if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contact)) {
          emailArray.push(contact);
        } else {
          hasInvalidContact = true;
        }
      });

      if (hasInvalidContact) {
        showToast(1, "Please enter valid email addresses and phone numbers.");
        return;
      }

      for (const userId of selectedUsers) {
        const data = await getUser(user.token, user.orgId, userId);
        console.log("Fetched User Details: ", data);
        const userDetails = data?.data?.user;
        console.log("User Details: ", userDetails);
        if (userDetails) {
          const email = userDetails.email;
          const phone = userDetails.phoneNumber;

          if (email) {
            emailArray.push(email);
          }
          if (phone) {
            phoneNumberArray.push(phone);
          }
        }
      }

      console.log("Emails: ", emailArray);
      console.log("Phone Numbers: ", phoneNumberArray);

      await shareAlert(
        user.token,
        alertId,
        emailArray,
        phoneNumberArray,
        expiration,
        note,
      );

      showToast(0, "Alert shared successfully!");
      handleClose();
    } catch (error) {
      console.error("Error sharing alert:", error);
      showToast(
        1,
        "There was an error sharing the alert. Please try again later.",
      );
    }
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      className="share-alert-modal flex justify-center items-center h-screen"
      centered
      footer={null}
      closable={false}
      width={510}
    >
      <div className="bg-white p-8 rounded-lg shadow-lg w-[500px] share-alert-modal-content">
        <h2 className="text-2xl font-semibold mb-4">Share Alert</h2>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleShare();
          }}
        >
          <label className="block text-gray-700 text-sm font-bold mb-2">
            Select User
          </label>
          <UserSelect
            className="bigInput"
            role={""}
            maxSelectNumber={15}
            onChange={handleUserSelect} // Pass handleUserSelect to capture selected users
            value={selectedUsers} // Set the value to the selected users state
          />
          <div className="my-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Contact Information
            </label>
            <input
              type="text"
              value={contactInfo}
              onChange={(e) => setContactInfo(e.target.value)}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              placeholder="Emails or phone numbers separated by , ; or spaces"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Expiration
            </label>
            <select
              value={expiration}
              onChange={(e) => setExpiration(e.target.value)}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            >
              <option value="1440">1 Day</option>
              <option value="4320">3 Days</option>
              <option value="10080">7 Days</option>
            </select>
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Note
            </label>
            <textarea
              value={note}
              onChange={(e) => setNote(e.target.value)}
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              placeholder="Write a note"
            />
          </div>
          <div className="flex items-center justify-end">
            <button
              type="button"
              onClick={handleClose}
              className="mr-2 rounded-xl bg-white px-4 py-2 border border-blue-500 hover:border-blue-400 text-base transition-colors text-blue-500 hover:text-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 active:bg-blue-600 aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              className={`${!contactInfo && selectedUsers.length === 0 ? "bg-gray-400" : "bg-blue-500 hover:bg-blue-600"} text-white font-bold py-2 px-4 rounded-xl focus:outline-none focus:shadow-outline`}
              disabled={!contactInfo && selectedUsers.length === 0}
            >
              Share
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default ShareAlertModal;
